<h1 mat-dialog-title >{{data.title}}</h1>
  <mat-card-content >
    <form [formGroup]="equipoForm">

      <div style="display: flex;justify-content: space-around;flex-wrap: wrap" formGroupName="equipo">

        <div style="flex-direction: column;display: flex">
            <mat-form-field appearance="outline" >
                <mat-label>Código</mat-label>
                <input matInput placeholder="Código" formControlName="codigo" name="codigo" required>
              </mat-form-field>
          <mat-form-field appearance="outline" >
            <mat-label>Nombre</mat-label>
            <input matInput placeholder="Nombre" formControlName="nombre" name="nombre" required>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Categoría</mat-label>
            <input matInput placeholder="Categoría"formControlName="categoria" name="categoria" required>
          </mat-form-field>

          <mat-form-field appearance="outline" >
            <mat-label>Marca</mat-label>
            <input matInput placeholder="Marca" formControlName="marca" name="marca" required>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Talla</mat-label>
            <input matInput placeholder="Talla"formControlName="talla" name="talla" required>
          </mat-form-field>

          <mat-form-field appearance="outline" >
            <mat-label>Modelo</mat-label>
            <input matInput placeholder="Modelo" formControlName="modelo" name="modelo" required>
          </mat-form-field>

        </div>

      </div>

      <mat-dialog-actions align="center">
        <button mat-raised-button mat-dialog-close>Cancelar</button>
        <button mat-raised-button style="background-color: #e95a1a;color: white" *ngIf="this.data.estado==1" (click)="updateEquipo()">{{data.title}}</button>
        <button mat-raised-button style="background-color: #e95a1a;color: white" *ngIf="this.data.estado==2" (click)="createEquipo()">{{data.title}}</button>
      </mat-dialog-actions>

    </form>
  </mat-card-content>
